import { type ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import Datepicker from 'react-datepicker';
import styles from './birthdate-input.module.scss';
import { Icon } from '@utmb/design-system/icons/Icon';
import { IconEnum } from '@utmb/types/enum/IconEnum';
import { Input } from '@utmb/design-system/input/Input';
import 'react-datepicker/dist/react-datepicker.css';
export interface BirthdateInputProps {
    value: string | null;
    onChange: (value: string | null) => void;
    onBlur: any;
}

export function BirthdateInput({ value, onChange, onBlur }: BirthdateInputProps): ReactElement {
    const { t } = useTranslation();

    const createLocalDate = (dateString: string): Date => {
        const [year, month, day] = dateString.split('-').map(Number);
        return new Date(year, month - 1, day);
    };

    const formatToISOString = (date: Date): string => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    return (
        <Datepicker
            dateFormat="dd/MM/yyyy"
            id="birthdate"
            name="birthdate"
            onChange={(date: Date | null) => {
                if (date) {
                    const formatted = formatToISOString(date);
                    onChange(formatted);
                } else {
                    onChange(null);
                }
            }}
            selected={value ? createLocalDate(value) : null}
            peekNextMonth
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            autoComplete="off"
            placeholderText={t('common.birthdate')}
            onChangeRaw={(e) => {
                e.preventDefault();
            }}
            customInput={
                <div className={styles.customBirthdateInput}>
                    <Input
                        id="birthdate"
                        name="birthdate"
                        type="date"
                        readOnly
                        label={t('common.birthdate')}
                        value={value ?? ''}
                        onchange={(value: any) => {
                            if (value?.target?.value) {
                                onChange(value.target.value);
                            }
                        }}
                        onblur={onBlur}
                        require={true}
                    />
                    <div className={styles.calendarInputIcon}>
                        <Icon variant={IconEnum.CALENDAR} width={60} height={60} />
                    </div>
                </div>
            }
        />
    );
}
